const addTrailingSlash = (url: string) => (url.endsWith('/') ? url : `${url}/`)

export const urlMaker = (url: string) => (id?: number | string) => {
  if (typeof id === 'undefined') {
    return addTrailingSlash(url)
  }
  return `${addTrailingSlash(url)}${id}/`
}
